<template>
  <c-page>
    <div class="my-head">
      <img src="./image.png" class="my-head-img" />
      <div class="my-head-name">王二单</div>
      <div class="my-head-address">
        <el-icon ><Location /></el-icon>
        收货地址 |
        <el-icon ><Operation /></el-icon>
        切换账号
      </div>
      <!-- <div class="my-head-change">
        <el-icon ><Operation /></el-icon>
        切换账号</div> -->
      <div class="my-head-service">
        <el-icon :size="26" ><Service /></el-icon>
        <span>官方客服</span>
        </div>
      <div>
        <el-icon ><Setting /></el-icon>
        设置</div>
    </div>
  </c-page>
</template>

<script>
import {Location,Operation,Service,Setting } from "@element-plus/icons-vue";

export default {
  components: {
    Location,
    Operation,
    Service,Setting
  },
};
</script>


<style lang="less" scoped>
.page-container {
  display: flex;
  flex-direction: column;
}

.my-head {
  display: flex;
  justify-content: space-between;
  align-items: center;

  .my-head-img {
    width: 5.5rem;
    height: auto;
    margin-left: 1rem;
    margin-top: 1rem;
    border-radius: 10rem;
  }
  .my-head-name {
    font-size: 1.3rem;
    font-weight: bold;
    color: black;
    margin-top: -1rem;
    letter-spacing: 0.1rem;
  }
  .my-head-address{
    color: #000;
    margin-top: 3rem;
    margin-left: -6rem;
  }
  .my-head-service{
    display: flex;
  flex-direction: column;

    .my-head-service-img{}
  }
}
</style>